import React from "react"
import { Row, Col, Spinner, Pagination, Card, DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap"
import TableOfEntities from "./TableOfEntities"
import ListOptionsCard from "./ListOptionsCard"
import { extractUriParameter } from "../js/generic_functions"
import withHooks from "./WithHooks"

class ListPageContainer extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    this.state = {}
    this.dMgr.debug("init_state:", this.state)
  }

  render() {
    this.dMgr.rendering()

    if (this.props.listPagination.page !== 1 && this.props.listPagination.totalItems > 0 && this.props.tableRows.length === 0) {
      this.props.listPaginationUpdate({ page: 1 })
    }

    let toRender = (
      <Row>
        {(this.props.noCard === undefined || !this.props.noCard) && (
          <Col md={2}>
            <ListOptionsCard
              nbDisplayedEntities={this.props.nbDisplayedEntities}
              nbTotalEntities={this.props.tableRows.length}
              entityType={this.props.entityType}
              entitiesType={this.props.entitiesType}
              handleFilterSearch={this.props.handleFilterSearch}
              filters={this.props.filters}
              addEntity={this.props.addEntity}
              listFiltersUpdate={this.props.listFiltersUpdate}
            />
          </Col>
        )}
        {this.props.entities === null ? (
          <Col md={this.props.noCard === undefined || !this.props.noCard ? 10 : 12} className="text-center">
            <Spinner className="margin-top-100" animation="grow" variant="secondary" />
          </Col>
        ) : (
          <Col md={this.props.noCard === undefined || !this.props.noCard ? 10 : 12}>
            <Card bg="dark" text="white" className="box-shadow-lvl3">
              <Card.Body>
                {this.props.title && <Card.Title>{this.props.title}</Card.Title>}
                <Row>
                  <Col md={12}>
                    {/* {this.props.tableRows.length > 0 ? ( */}
                    <TableOfEntities
                      tableName={this.props.tableName}
                      referrerUrl={this.props.referrerUrl}
                      headers={this.props.tableHeaders}
                      rows={this.props.tableRows}
                      entityType={this.props.entityType}
                      entitiesType={this.props.entitiesType}
                      editEntity={this.props.editEntity}
                      deleteEntity={this.props.deleteEntity}
                      restoreEntity={this.props.restoreEntity}
                      listOrdersUpdate={this.props.listOrdersUpdate}
                      referrerPage="list"
                    />
                    {/* ) : (
                      this.props.t("entity." + this.props.entitiesType) + " " + this.props.t("message.notFound").toLowerCase()
                    )} */}
                  </Col>
                </Row>
                {this.props.tableRows.length > 0 ? (
                  <>
                    <hr className="margin-bottom-5 margin-top-m10" />
                    <Row>
                      <Col md={4} className="margin-top-3">
                        {this.props.t("app.displayedItems")}
                        {this.props.t("app.dbp")} {this.props.tableRows.length}/{this.props.listPagination.totalItems}
                      </Col>
                      <Col md={4} className="text-center">
                        {this.props.listPagination.previousPageUrl !== undefined || this.props.listPagination.nextPageUrl !== undefined ? (
                          <Pagination size="sm" variant="secondary" data-bs-theme="dark" className="pagination-container display-block-ruby">
                            {this.props.listPagination.firstPageUrl !== undefined &&
                            this.props.listPagination.firstPageUrl !== this.props.listPagination.previousPageUrl &&
                            this.props.listPagination.firstPageUrl !== this.props.listPagination.pageTypeUrl ? (
                              <Pagination.First
                                onClick={() => {
                                  this.props.listPaginationUpdate({ page: extractUriParameter(this.props.listPagination.firstPageUrl, "page") })
                                }}
                              />
                            ) : (
                              ""
                            )}
                            {this.props.listPagination.previousPageUrl !== undefined ? (
                              <Pagination.Prev
                                onClick={() => {
                                  this.props.listPaginationUpdate({ page: extractUriParameter(this.props.listPagination.previousPageUrl, "page") })
                                }}
                              />
                            ) : (
                              ""
                            )}
                            <Pagination.Item active>{this.props.listPagination.page}</Pagination.Item>
                            {this.props.listPagination.nextPageUrl !== undefined ? (
                              <Pagination.Next
                                onClick={() => {
                                  this.props.listPaginationUpdate({ page: extractUriParameter(this.props.listPagination.nextPageUrl, "page") })
                                }}
                              />
                            ) : (
                              ""
                            )}
                            {this.props.listPagination.lastPageUrl !== undefined &&
                            this.props.listPagination.lastPageUrl !== this.props.listPagination.nextPageUrl &&
                            this.props.listPagination.lastPageUrl !== this.props.listPagination.pageTypeUrl ? (
                              <Pagination.Last
                                onClick={() => {
                                  this.props.listPaginationUpdate({ page: extractUriParameter(this.props.listPagination.lastPageUrl, "page") })
                                }}
                              />
                            ) : (
                              ""
                            )}
                          </Pagination>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col md={4} className="text-end margin-top-3">
                        {this.props.t("app.itemsPerPage")}
                        {this.props.t("app.dbp")}{" "}
                        <DropdownButton
                          as={ButtonGroup}
                          data-bs-theme="dark"
                          className="itemsperpage-dropdown"
                          size="sm"
                          variant="secondary"
                          title={this.props.listPagination.itemsPerPage}
                          onSelect={(eventKey) => {
                            this.props.listPaginationUpdate({ itemsPerPage: parseInt(eventKey), page: 1 })
                          }}
                        >
                          <Dropdown.Item eventKey="1">1</Dropdown.Item>
                          <Dropdown.Item eventKey="10">10</Dropdown.Item>
                          <Dropdown.Item eventKey="20">20</Dropdown.Item>
                          <Dropdown.Item eventKey="50">50</Dropdown.Item>
                        </DropdownButton>
                      </Col>
                    </Row>
                  </>
                ) : null}
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(ListPageContainer)
